import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62117966&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62117966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62117966')) {
      api.createRecord('62117966', component.options)
    } else {
      api.reload('62117966', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62117966&scoped=true", function () {
      api.rerender('62117966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/newReplaceBag/index.vue"
export default component.exports